/** Coverage is separate from observed hazard: an incomplete source may still
 * prove positive flood exposure, but cannot establish flood-free land. */
/** Fixed coordinate grid (degrees) used only after polygon-clipping fails to
 * reconstruct an output ring at exact precision. */
export const GEOMETRY_PRECISION_SNAP_DEG = 1e-9;
/** Largest vertex displacement the grid can cause: half a cell along both
 * axes at 111,320 m per degree, i.e. the cell diagonal, rounded up (mm). */
export const GEOMETRY_PRECISION_SNAP_MAX_SHIFT_MM = (Math.ceil(0.5 * GEOMETRY_PRECISION_SNAP_DEG * 111_320 * Math.SQRT2 * 1000 * 100) / 100).toFixed(2);

export interface FloodScreeningCoverage {
  status: 'complete' | 'partial' | 'unknown';
  reason: string;
  observedZones: string[];
  observedSourceRoles?: string[];
  sourceKind?: 'refdata-snapshot' | 'live-nfhl';
  sourceAuthority?: string;
  sourceVersion?: string;
  sourceVintageDate?: string;
  /** Fractions refer to the queried polygon, never a point sample estimate. */
  mappedFraction?: number;
  unavailableFraction?: number;
  conflictFraction?: number;
  /** Present only when the exact pairwise computation failed inside
   * polygon-clipping and a disclosed fallback tier produced this coverage;
   * such coverage is never reported as complete. */
  geometryTier?: 'single-sweep' | 'precision-snap';
  /** Present only with geometryTier 'precision-snap': the fixed coordinate
   * grid (degrees) the coverage was recomputed on. */
  precisionSnapDeg?: number;
}
